import styled from 'styled-components';

import { BREAKPOINTS } from 'constants/breakpoints';
import { colours, fonts } from 'themes/default';
const { fontFamily } = fonts;

const defaultPadding = 16;
const MOBILE_BREAKPOINT = `${BREAKPOINTS.lg.max}px`;

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${colours.Core.CoreNavy.opacity(90)};
  z-index: 1000;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    align-items: flex-start;
    overflow-y: auto;
    padding: ${defaultPadding / 2}px;
    box-sizing: border-box;
  }
`;

export const ModalContainer = styled.div`
  display: flex;
  overflow-y: auto;
  overflow-x: hidden;
  flex-direction: column;
  width: ${({ minWidth }) => `min(${minWidth ?? '900px'}, calc(100vw - ${defaultPadding * 2}px))`};
  max-height: calc(100vh - ${defaultPadding * 2}px);
  background: ${colours.Greyscale.SilverGrey};
  padding: 0 ${defaultPadding * 2}px ${defaultPadding * 2}px ${defaultPadding * 2}px;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    width: calc(100vw - ${defaultPadding}px);
    max-height: calc(100vh - ${defaultPadding}px);
    padding: 0 ${defaultPadding}px ${defaultPadding}px ${defaultPadding}px;
  }
`;

export const ModalContents = styled.div`
  background: white;
  padding: ${defaultPadding}px;
  border-bottom: 1px solid rgb(188, 188, 188);
  font-family: ${fontFamily};
  margin-bottom: 16px;
`;

export const ModalTopRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  min-height: ${defaultPadding * 4}px;
`;

export const ModalBottomRow = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: ${defaultPadding / 2}px;
  margin-top: auto;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    > * {
      width: 100%;
      min-height: 32px;
      height: auto;
      white-space: normal;
      word-break: break-word;
    }

    > * > div {
      white-space: normal;
      line-height: 1.3;
    }
  }
`;

export const ModalHeading = styled.h1`
  font-family: ${fontFamily};
  font-size: 32px;
  font-weight: normal;
  margin-bottom: 0;
  margin-top: 0;
  padding: 20px 0;
  color: ${colours.Greyscale.CharcoalGrey};
`;

export const ModalSubtitle = styled.p`
  font-family: ${fontFamily};
  font-size: 14px;
  color: ${colours.Greyscale.CharcoalGrey};
  white-space: pre-line;
`;

export const CloseButton = styled.button`
  border: none;
  background: none;
  outline: none;
  cursor: pointer;
  color: ${colours.Shades.BlueShade40};
  font-size: 14px;
  display: flex;
  align-items: center;
`;

export const CloseText = styled.span`
  text-decoration: underline;
  padding-right: ${4}px;
`;
